export default __webpack_public_path__ + "static/media/Image_55.4097f96f.svg";